<form
  [formGroup]="activityFormService.activityForm"
  class="flex flex-col gap-4"
>
  <h4 class="text-primary-900">
    {{ "prestation.activityDuration.title" | transloco }}
  </h4>
  <div class="flex flex-1 flex-col">
    <label for="days" class="text-paragraph-xs-med text-greyscale-700">
      {{ "calculator.label.days" | transloco }}
    </label>
    <p-inputNumber id="days" formControlName="days" [fluid]="true" />
    <app-error [control]="activityFormService.activityForm.get('days')!" />
  </div>
</form>
